import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError, map, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

let totalRequests = 0;

export const interceptorServiceInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(NgxSpinnerService);
  
  totalRequests++;
  spinner.show();

  return next(req).pipe(
    map((event: any) => {
      if (event && 'body' in event && event.body) {
        // Verificar el status dentro del body de la respuesta 200
        if (event.body.statusCode === 500) {
          Swal.fire({
            icon: 'error',
            title: 'Error del Servidor',
            text: event.body.body.message || 'Ha ocurrido un error en el servidor. Por favor, intenta más tarde.',
            confirmButtonText: 'Aceptar'
          });
          throw new Error(event.body.body.message || 'Error interno del servidor');
        }
        
        // Verificar otros códigos de estado en el body
        if (event.body.statusCode === 400) {
          Swal.fire({
            icon: 'warning',
            title: 'Solicitud Incorrecta',
            text: event.body.body.message || 'Los datos enviados no son correctos.',
            confirmButtonText: 'Entendido'
          });
        }
        
        if (event.body.statusCode === 401) {
          Swal.fire({
            icon: 'error',
            title: 'No Autorizado',
            text: event.body.body.message || 'No tienes autorización para realizar esta acción.',
            confirmButtonText: 'Aceptar'
          });
        }
        
        if (event.body.statusCode === 403) {
          Swal.fire({
            icon: 'error',
            title: 'Acceso Denegado',
            text: event.body.body.message || 'No tienes permisos para acceder a este recurso.',
            confirmButtonText: 'Aceptar'
          });
        }

        if (event.body.statusCode === 404 || event.body.statusCode === 502 || event.body.statusCode === 503) {
          Swal.fire({
            icon: 'error',
            title: event.body.body.error,
            text: event.body.body.message,
            confirmButtonText: 'Aceptar'
          });
        }


      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.error instanceof ErrorEvent) {
        // Error del cliente
        Swal.fire({
          icon: 'error',
          title: 'Error de Cliente',
          text: 'Ha ocurrido un error en tu conexión. Por favor, verifica tu internet.',
          confirmButtonText: 'Entendido'
        });
      } else {
        // Errores del servidor
        switch (error.status) {
          case 400:
            Swal.fire({
              icon: 'warning',
              title: 'Solicitud Incorrecta',
              text: 'Los datos enviados no son correctos.',
              confirmButtonText: 'Entendido'
            });
            break;
          
          case 401:
            Swal.fire({
              icon: 'error',
              title: 'No Autorizado',
              text: 'No tienes autorización para realizar esta acción.',
              confirmButtonText: 'Aceptar'
            });
            break;

          case 403:
            Swal.fire({
              icon: 'error',
              title: 'Acceso Denegado',
              text: 'No tienes permisos para acceder a este recurso.',
              confirmButtonText: 'Aceptar'
            });
            break;

          case 404:
            Swal.fire({
              icon: 'warning',
              title: 'No Encontrado',
              text: 'El recurso que buscas no existe.',
              confirmButtonText: 'Aceptar'
            });
            break;

          case 500:
            Swal.fire({
              icon: 'error',
              title: 'Error del Servidor',
              text: 'Ha ocurrido un error en el servidor. Por favor, intenta más tarde.',
              confirmButtonText: 'Aceptar'
            });
            break;

          case 503:
            Swal.fire({
              icon: 'error',
              title: 'Servicio No Disponible',
              text: 'El servicio no está disponible en este momento. Por favor, intenta más tarde.',
              confirmButtonText: 'Aceptar'
            });
            break;

          default:
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ha ocurrido un error inesperado. Por favor, intenta más tarde.',
              confirmButtonText: 'Aceptar'
            });
        }
      }
      return throwError(() => error);
    }),
    finalize(() => {
      totalRequests--;
      if (totalRequests === 0) {
        spinner.hide();
      }
    })
  );
};